import { pageURLs } from "@/constants/pageURLs";

export const isAgentDirectoryPath = (pathName) => {
  const path = String(pathName || "").replace(/\/+$/, "");
  return path === pageURLs.agentDirectory || path.startsWith(`${pageURLs.agentDirectory}/`);
};
